import { cloudChiprApi } from "@/services/cloudchipr.api";
import { RootState } from "@/store/store";
import { commitmentsCurrentOrgIdSelector } from "@/store/commitments/selectors/common/commitmentsCurrentOrgIdSelector";

export const selector =
  cloudChiprApi.endpoints
    .getV2UsersMeOrganisationsCurrentSavingsPlansPotentialSavings.select;

export const getCurrentSavingPlansPotentialSavingsLoadingSelector = (
  state: RootState,
) => {
  const providerOrganisationId = commitmentsCurrentOrgIdSelector(state);

  return selector({
    providerOrganisationId,
  })(state)?.isLoading;
};
